import {combineReducers} from 'redux';
import setstore from './setStore';

export default combineReducers({
  setstore,
});
